// extracted by mini-css-extract-plugin
export default {"container":"Error_container__XAL-s","outlined":"Error_outlined__T2CJh","logo":"Error_logo__EzlIx"};